var React = require('react');

function TrianglesBottom (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2 125.969L122.847 256.878M2 125.969L133.799 137.899M2 125.969L249.03 91.0333M122.847 256.878L133.799 137.899M122.847 256.878L249.03 91.0333M133.799 137.899L249.03 91.0333","stroke":"#DADADA","key":0}),React.createElement("path",{"d":"M589 200.141L701.27 267.14M589 200.141L666.69 197.995M589 200.141L715.014 163.181M701.27 267.14L666.69 197.995M701.27 267.14L715.014 163.181M666.69 197.995L715.014 163.181","stroke":"#DADADA","key":1})]);
}

TrianglesBottom.defaultProps = {"width":"758","height":"279","viewBox":"0 0 758 279","fill":"none"};

module.exports = TrianglesBottom;

TrianglesBottom.default = TrianglesBottom;
